import ConsumptionSection from '../components/consumption-section/ConsumptionSection.tsx'
import { ENERGY_TYPES } from '@boltenergy-be/shared'

const ElectricityConsumption = () => {
  return <ConsumptionSection energyType={ENERGY_TYPES.electricity} />
}

export default ElectricityConsumption
